var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Kyc',{attrs:{"data-component":_vm.$options.name}})
}
var staticRenderFns = []

export { render, staticRenderFns }